class DataCardsIndex {
	constructor() {
		this.init();
	}

	init() {
        // labels display for filters section
        this.facetLabelsInit();

        // Add query parameters for filtered (single card) datasets
        this.requestLinks();

        // loading icon
        this.dataLoadingInit();        
	}

    facetLabelsInit(){
        $(document).on('facetwp-loaded', function() {
            $('.facetwp-facet').each(function(index) {
                var facet = $(this);
                var facet_name = facet.attr('data-name');
                var facet_type = facet.attr('data-type');
                var facet_label = FWP.settings.labels[facet_name];
                if (!['pager', 'sort', 'reset'].includes(facet_type)) { // Add or remove excluded facet types to/from the array
                    if (facet.closest('.facet-wrap').length < 1 && facet.closest('.facetwp-flyout').length < 1) {
                        let facetId = 'td-facet-' + index;
                        facet.prop('id', facetId);
                        facet.wrap('<div class="facet-wrap"></div>');
                        facet.before('<h3 class="facet-label">' + facet_label + ':</h3>');
                    }
                }
            });
        });
    }

    requestLinks(){
        $(document).ready(function() {

            // facetWP filters
            const filterParams = [
                'drug_name',
                'sample_type',
                'population_type',
                'admin_route',
                'formulation_type',
                'initial_dose',
                'study_design',
                'gestation_stage',
                'study_id',
                'dosing_schedule',
                'study_details_filter',
            ];

            $(document).on('click','a.data-request-all',function(e){
                e.preventDefault();

                if(!$('.selected-filters__selection .facetwp-selections li').length){
                    return false;
                }

                // Get the current href of the link
                const currentHref = this.getAttribute("href");

                // Initial URL
                const linkUrl = new URL(currentHref);

                // Get the current parameters of the link
                const linkParams = new URLSearchParams(linkUrl.search);                

                // Loop through the array of parameters to check
                filterParams.forEach(param => {
                   const checkParam = 'data_cards_' + param; 
                   let paramValue = '';
                    // use the available (selected or all available) params
                    if($('div[data-name='+checkParam+']:first').length){
                        const inputWrap = $('div[data-name='+checkParam+']:first');
                        let dropdown = inputWrap.find('.facetwp-dropdown:first');
                        if(dropdown.length){
                            if(dropdown.attr('aria-label') == 'All'){
                                dropdown.find('option').each(function(){
                                    if($(this).text() != 'All'){
                                        paramValue += (paramValue != '' ? ',' : '') + $(this).text();
                                    } 
                                });
                            }else{
                                paramValue = dropdown.attr('aria-label');
                            }
                        }else{
                            let checkboxes = inputWrap.find('.facetwp-checkbox.checked');
                            checkboxes = checkboxes.length ? checkboxes : inputWrap.find('.facetwp-checkbox');
                            if(checkboxes.length){
                                paramValue = '';
                                checkboxes.each(function(){
                                    paramValue += (paramValue != '' ? ',' : '') + $(this).find('.facetwp-display-value').text();
                                });
                            }
                        }
                        let finalParam = param == 'study_id' ? 'pkrxiv_study_id' : param;

                        // Update or add the parameter to the link's URL
                        linkParams.set(finalParam, paramValue);                        
                    }
                });

                // Update the link's href with the modified parameters
                linkUrl.search = linkParams.toString();
                this.setAttribute("href", linkUrl.toString());

                // Redirect to the updated URL
                window.location.href = linkUrl.toString();
            });

            $(document).on('click','.cards-grid a.data-request',function(e){
                e.preventDefault();
                
                // Get the current href of the link
                const currentHref = this.getAttribute("href");

                // Parse the existing query parameters from the href
                const linkUrl = new URL(currentHref);

                // Get the current parameters of the link
                const linkParams = new URLSearchParams(linkUrl.search);

                // Get the current URL parameters (if any) from the page URL
                const urlParams = new URLSearchParams(window.location.search);

                // Loop through the array of parameters to check
                filterParams.forEach(param => {
                    const checkParam = 'data_cards_' + param; 
                    const checkParamPrefix = '_';
                    const checkParamRef = checkParamPrefix + checkParam;
                    if (param != 'study_id' && urlParams.has(checkParamRef)) {
                        // Get the value of the current parameter
                        let paramValue = urlParams.get(checkParamRef);
                        // use the display value rather than the url param value (facetWP uses term slugs for filtering, we need the values)
                        if(paramValue && $('div[data-name='+checkParam+']:first').length){
                            const inputWrap = $('div[data-name='+checkParam+']:first');
                            let dropdown = inputWrap.find('.facetwp-dropdown:first');
                            if(dropdown.length){
                                paramValue = dropdown.attr('aria-label');
                            }else{
                                let checkboxes = inputWrap.find('.facetwp-checkbox.checked');
                                if(checkboxes.length){
                                    paramValue = '';
                                    checkboxes.each(function(){
                                        paramValue += (paramValue != '' ? ',' : '') + $(this).find('.facetwp-display-value').text();
                                    });
                                }
                            }
                            // Update or add the parameter to the link's URL
                            linkParams.set(param, paramValue);

                        }
                    }
                });

                // Update the link's href with the modified parameters
                linkUrl.search = linkParams.toString();
                this.setAttribute("href", linkUrl.toString());

                // Redirect to the updated URL
                window.location.href = linkUrl.toString();
            });
        });
    }

    dataLoadingInit(){
        $(document).ready(function() {
            $(document).on('facetwp-refresh', function() {
                if (FWP.loaded && !$('.custom-loader').length) {
                    $('.selected-filters__results:first').append('<img class="custom-loader" src="' + tdI18n.spinner_blue + '" alt="waiting" aria-hidden="true" />');
                }
            });

            $(document).on('facetwp-loaded', function() {
                $('.custom-loader').remove();
            });
        });
    }
}

export default DataCardsIndex;